import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    LineElement,   
    PointElement, 
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

// const BarChart = (props) => {
    // const { labels = [], prefix = "", suffix = "", datasets,  yAxisAsPercentage = false } = props;
    const BarChart = (props) => {
    const {
        labels = [],
        prefix = "",
        suffix = "",
        datasets,
        yAxisAsPercentage = false,
        yAxisTitle = "Amount",
        showDataLabels = false,
    } = props;
    const options = {
        maintainAspectRatio: false, // Set this to false to make the chart responsive
        responsive: true, // Set this to true to enable responsiveness
        layout: {
            padding: {
                top: showDataLabels ? 32 : 0,
            },
        },
        plugins: {
            legend: {
                position: "none",
            },
            title: {
                display: true,
                text: "",
            },
            datalabels: {
                display: showDataLabels,
                color: 'black',
                anchor: 'end',
                align: 'end',
                offset: (context) => 4 + context.datasetIndex * 12,
                font: {
                    size: 10,
                    weight: '600',
                },
                formatter: (value) => `${prefix}${Math.round(value)}${yAxisAsPercentage ? "%" : suffix}`,
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                max: yAxisAsPercentage ? 100 : null, 
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function (value) {
                        return prefix + value + (yAxisAsPercentage ? "%" : suffix);
                    },
                },
                title: {
        display: true,
        // text: "Amount",
        text: yAxisTitle,
        font: {
          size: 14,
          weight: "bold",
        },
      },
            },
        },
    };
    const data = {
        labels: labels,
        datasets: datasets.map((value) => {
            return {
                    ...value,
                    // A fixed barThickness stays the same width no matter how wide the
                    // chart's container is. A max cap has the same problem once the
                    // container is wide enough to hit it: each bar gets centered in a
                    // slot much bigger than the capped bar, so the two grouped bars
                    // drift apart instead of staying together. Leaving thickness
                    // unset lets Chart.js size bars purely from barPercentage, so
                    // both bars (and the small gap between them) grow together with
                    // the container — which is what gives data labels room without
                    // splitting the group apart.
                    ...(showDataLabels
                            ? { barPercentage: 1, categoryPercentage: 0.40 }
                            : { barThickness: 40 }),
                    borderRadius: 4,
            };
        }),
    };
    return (
        <div className="w-full h-full">
            <Bar options={options} data={data} />
            {datasets?.length > 0 && (
                <div className="flex justify-center gap-[24px]">
                    {datasets?.map((value, index) => (
                        <span
                            className="flex items-center gap-[8px]"
                            key={index * 3}
                        >
                            <div
                                className="w-[11px] h-[11px] rounded-[50%] bg-red-500"
                                style={{
                                    backgroundColor: value?.backgroundColor,
                                }}
                            ></div>
                            <div className="">{value?.label}</div>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};
export default BarChart;
